var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as channelsApi from './channelsApi';
import * as projectsApi from './projectsApi';
// Note: We don't need to actually save a channel for local storage.
// However, we want to make a best effort to keep track of the original local storage
// key when switching levels, so we store it here.
var LocalChannelsStore = /** @class */ (function () {
    function LocalChannelsStore() {
        this.localStorageKey = undefined;
    }
    LocalChannelsStore.prototype.load = function (key) {
        this.localStorageKey = key;
        return Promise.resolve(new Response('{}'));
    };
    // We don't support changing keys for local storage, so we just return the
    // existing key, if we have one. If we don't have one, we return a default key.
    LocalChannelsStore.prototype.loadForLevel = function () {
        var key = this.localStorageKey || 'savedCodeLocal';
        return Promise.resolve(new Response("{channel: ".concat(key, "}")));
    };
    LocalChannelsStore.prototype.save = function () {
        return Promise.resolve(new Response(''));
    };
    return LocalChannelsStore;
}());
export { LocalChannelsStore };
var RemoteChannelsStore = /** @class */ (function () {
    function RemoteChannelsStore() {
        this.defaultChannel = { name: 'New Project' };
    }
    RemoteChannelsStore.prototype.loadForLevel = function (levelId, scriptId) {
        return projectsApi.getChannelForLevel(levelId, scriptId);
    };
    RemoteChannelsStore.prototype.load = function (channelId) {
        return channelsApi.get(channelId);
    };
    RemoteChannelsStore.prototype.save = function (channel) {
        channel = __assign(__assign({}, this.defaultChannel), channel);
        return channelsApi.update(channel);
    };
    return RemoteChannelsStore;
}());
export { RemoteChannelsStore };
